import { render, staticRenderFns } from "./ProfilParamsSecurity.vue?vue&type=template&id=6656cdc2&"
import script from "./ProfilParamsSecurity.vue?vue&type=script&lang=js&"
export * from "./ProfilParamsSecurity.vue?vue&type=script&lang=js&"
import style0 from "./ProfilParamsSecurity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports